(function () {
  'use strict';

  function fmt(cents) {
    var kr = Math.round(cents / 100);
    return String(kr).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
  }

  function optionIndex(product, words) {
    if (!product || !product.options) return -1;
    for (var i = 0; i < product.options.length; i++) {
      var name = String(product.options[i]).toLowerCase();
      for (var j = 0; j < words.length; j++) {
        if (name.indexOf(words[j]) !== -1) return i;
      }
    }
    return -1;
  }

  function init(root) {
    var dataEl = root.querySelector('[data-lp-products]');
    var products = {};
    try { products = JSON.parse(dataEl.textContent); } catch (e) { products = {}; }

    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var state = { breed: null, size: null, palette: null, pkg: 'standard', date: null, age: null, name: '', phone: '' };
    var ageRequired = root.getAttribute('data-age-required') !== 'false';

    // ----- delivery date -----
    var MONTHS = ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'];
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function toIso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    function parseIso(s) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s || '').trim());
      if (!m) return null;
      var d = new Date(+m[1], +m[2] - 1, +m[3]);
      return isNaN(d.getTime()) ? null : d;
    }
    function nice(d) { return d.getDate() + '. ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear(); }
    var dateRequired = root.getAttribute('data-date-required') !== 'false';
    var minDays = Math.max(7, parseInt(root.getAttribute('data-min-days'), 10) || 7);
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var minDate = new Date(today.getTime()); minDate.setDate(minDate.getDate() + minDays);
    var first = parseIso(root.getAttribute('data-first-date'));
    if (first && first > minDate) minDate = first;
    var maxDate = new Date(minDate.getTime()); maxDate.setFullYear(maxDate.getFullYear() + 1);
    var dateInput = root.querySelector('[data-date-input]');
    if (dateInput) {
      dateInput.min = toIso(minDate);
      dateInput.max = toIso(maxDate);
    }

    var params = new URLSearchParams(window.location.search);
    var pre = params.get('pakke');
    if (pre && root.querySelector('#lp-pkg-' + pre)) {
      root.querySelector('#lp-pkg-' + pre).checked = true;
      state.pkg = pre;
    }
    var checkedPal = q('input[name="lp-palette"]:checked');
    if (checkedPal) state.palette = checkedPal.value;

    function sizeIdx(p) { return optionIndex(p, ['størrelse', 'storrelse', 'size']); }
    function palIdx(p) { return optionIndex(p, ['palett', 'farge', 'color', 'colour']); }

    function findVariant(p) {
      if (!p || !state.size) return null;
      var si = sizeIdx(p), pi = palIdx(p);
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        var okSize = si === -1 || v.options[si] === state.size;
        var okPal = pi === -1 || v.options[pi] === state.palette;
        if (okSize && okPal) return v;
      }
      return null;
    }

    function minPrice(p, size) {
      if (!p) return null;
      var si = sizeIdx(p), min = null;
      p.variants.forEach(function (v) {
        if (size && si !== -1 && v.options[si] !== size) return;
        if (min === null || v.price < min) min = v.price;
      });
      return min;
    }

    function render() {
      // size text
      q('[data-size-text]').textContent = state.size
        ? 'Vi pakker i størrelse ' + state.size + '.'
        : 'Velg rase, så finner vi riktig størrelse.';

      // package prices
      qa('[data-pkg-price]').forEach(function (el) {
        var p = products[el.getAttribute('data-pkg-price')];
        var m = minPrice(p, state.size);
        if (m !== null) el.textContent = (state.size ? '' : 'fra ') + fmt(m);
      });

      // preview colours
      var pal = q('input[name="lp-palette"]:checked');
      if (pal) {
        var heart = root.querySelector('[data-preview-paw] .lp-heart');
        if (heart) heart.setAttribute('fill', pal.getAttribute('data-main'));
        q('[data-dot="main"]').style.background = pal.getAttribute('data-main');
        q('[data-dot="accent"]').style.background = pal.getAttribute('data-accent');
        q('[data-dot="detail"]').style.background = pal.getAttribute('data-detail');
      }

      // contents list
      qa('[data-items]').forEach(function (ul) {
        ul.hidden = ul.getAttribute('data-items') !== state.pkg;
      });

      // summary
      var p = products[state.pkg];
      var pkgLabel = root.querySelector('#lp-pkg-' + state.pkg + ' + label .lp-option__title');
      q('[data-sum="breed"]').textContent = state.breed || 'Ikke valgt';
      q('[data-sum="size"]').textContent = state.size || 'Ikke valgt';
      q('[data-sum="palette"]').textContent = state.palette || '–';
      q('[data-sum="pkg"]').textContent = pkgLabel ? pkgLabel.textContent : state.pkg;
      q('[data-sum="age"]').textContent = state.age != null ? state.age + (state.age === 1 ? ' uke' : ' uker') : 'Ikke skrevet inn';
      q('[data-sum="date"]').textContent = state.date ? nice(state.date) : 'Ikke valgt';
      q('[data-delivery-text]').textContent = state.date
        ? 'Ønsket levering: ' + nice(state.date) + '.'
        : 'Velg ønsket leveringsdato.';

      var isPremium = state.pkg === 'premium';
      q('[data-name-tag]').hidden = !isPremium;
      q('[data-sum-name-row]').hidden = !isPremium;
      q('[data-sum="name"]').textContent = state.name || 'Ikke skrevet inn';
      q('[data-sum-phone-row]').hidden = !isPremium;
      q('[data-sum="phone"]').textContent = state.phone || 'Ikke skrevet inn';
      var needName = isPremium && !state.name;
      var needPhone = isPremium && !state.phone;

      var v = findVariant(p);
      var btn = q('[data-add]');
      var hint = q('[data-hint]');
      if (v && needName) {
        q('[data-sum="price"]').textContent = fmt(v.price);
        btn.disabled = true;
        hint.hidden = false;
        hint.textContent = 'Skriv inn navnet til navneskiltet for å fortsette.';
      } else if (v && needPhone) {
        q('[data-sum="price"]').textContent = fmt(v.price);
        btn.disabled = true;
        hint.hidden = false;
        hint.textContent = 'Skriv inn telefonnummeret til navneskiltet for å fortsette.';
      } else if (v && ageRequired && state.age == null) {
        q('[data-sum="price"]').textContent = fmt(v.price);
        btn.disabled = true;
        hint.hidden = false;
        hint.textContent = 'Skriv hvor gammel valpen er (i uker) for å fortsette.';
      } else if (v && dateRequired && !state.date) {
        q('[data-sum="price"]').textContent = fmt(v.price);
        btn.disabled = true;
        hint.hidden = false;
        hint.textContent = 'Velg ønsket leveringsdato for å fortsette.';
      } else if (v) {
        q('[data-sum="price"]').textContent = fmt(v.price);
        btn.disabled = false;
        hint.hidden = true;
      } else {
        var m = minPrice(p, state.size);
        q('[data-sum="price"]').textContent = m !== null ? (state.size ? '' : 'fra ') + fmt(m) : '–';
        btn.disabled = true;
        hint.hidden = false;
        hint.textContent = !p
          ? 'Denne pakken er ikke klar for bestilling ennå.'
          : (!state.size ? 'Velg rase for å se riktig pris og størrelse.' : 'Denne kombinasjonen er ikke tilgjengelig.');
      }
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-breed-select')) {
        var opt = t.options[t.selectedIndex];
        var s = opt.getAttribute('data-size');
        var pick = q('[data-size-pick]');
        if (t.value === '__annen') {
          var other = q('[data-breed-other]');
          state.breed = other.value.trim() ? 'Annen rase: ' + other.value.trim() : 'Annen rase';
          state.size = null;
          qa('input[name="lp-size"]').forEach(function (r) { r.checked = false; });
          pick.hidden = false;
          other.focus();
        } else {
          state.breed = t.value;
          state.size = s || null;
          pick.hidden = true;
        }
      } else if (t.hasAttribute('data-breed-other')) {
        return;
      } else if (t.name === 'lp-date') {
        var d = parseIso(t.value);
        var help = q('[data-date-help]');
        if (d && d >= minDate && d <= maxDate) {
          state.date = d;
          t.removeAttribute('aria-invalid');
          if (help.dataset.orig) help.textContent = help.dataset.orig;
        } else {
          state.date = null;
          if (t.value) {
            t.setAttribute('aria-invalid', 'true');
            if (!help.dataset.orig) help.dataset.orig = help.textContent;
            help.textContent = 'Velg en dato mellom ' + nice(minDate) + ' og ' + nice(maxDate) + '.';
          }
        }
      } else if (t.name === 'lp-size') {
        state.size = t.value;
      } else if (t.name === 'lp-palette') {
        state.palette = t.value;
      } else if (t.name === 'lp-pkg') {
        state.pkg = t.value;
      }
      render();
    });

    var ageInput = q('[data-age-input]');
    if (ageInput) {
      var ageHelp = q('[data-age-help]');
      var ageHelpOrig = ageHelp.textContent;
      var aMin = parseInt(ageInput.min, 10) || 0, aMax = parseInt(ageInput.max, 10) || 104;
      ageInput.addEventListener('input', function () {
        var raw = ageInput.value.trim();
        var n = /^\d{1,3}$/.test(raw) ? parseInt(raw, 10) : NaN;
        if (!isNaN(n) && n >= aMin && n <= aMax) {
          state.age = n;
          ageInput.removeAttribute('aria-invalid');
          ageHelp.textContent = ageHelpOrig;
        } else {
          state.age = null;
          if (raw) {
            ageInput.setAttribute('aria-invalid', 'true');
            ageHelp.textContent = 'Skriv et helt antall uker mellom ' + aMin + ' og ' + aMax + '.';
          } else {
            ageInput.removeAttribute('aria-invalid');
            ageHelp.textContent = ageHelpOrig;
          }
        }
        render();
      });
    }

    var nameInput = q('[data-name-input]');
    if (nameInput) {
      nameInput.addEventListener('input', function () {
        state.name = nameInput.value.trim();
        render();
      });
    }

    // Telefonnummer: norsk nummer med 8 siffer, valgfritt +47/0047 foran
    function cleanPhone(raw) {
      var d = String(raw || '').replace(/[\s.\-()]/g, '');
      if (/^\+47/.test(d)) d = d.slice(3); else if (/^0047/.test(d)) d = d.slice(4);
      return /^\d{8}$/.test(d) ? d.slice(0, 3) + ' ' + d.slice(3, 5) + ' ' + d.slice(5) : '';
    }
    var phoneInput = q('[data-phone-input]');
    if (phoneInput) {
      var phoneHelp = q('[data-phone-help]');
      var phoneHelpOrig = phoneHelp.textContent;
      phoneInput.addEventListener('input', function () {
        state.phone = cleanPhone(phoneInput.value);
        if (state.phone || !phoneInput.value.trim()) { phoneInput.removeAttribute('aria-invalid'); phoneHelp.textContent = phoneHelpOrig; }
        render();
      });
      phoneInput.addEventListener('blur', function () {
        if (phoneInput.value.trim() && !state.phone) {
          phoneInput.setAttribute('aria-invalid', 'true');
          phoneHelp.textContent = 'Sjekk nummeret. Det skal være 8 siffer, for eksempel 912 34 567.';
        } else if (state.phone) { phoneInput.value = state.phone; }
      });
    }

    var otherInput = q('[data-breed-other]');
    if (otherInput) {
      otherInput.addEventListener('input', function () {
        var v = otherInput.value.trim();
        state.breed = v ? 'Annen rase: ' + v : 'Annen rase';
        render();
      });
    }

    q('[data-add]').addEventListener('click', function () {
      var v = findVariant(products[state.pkg]);
      if (!v || (dateRequired && !state.date) || (state.pkg === 'premium' && (!state.name || !state.phone))) return;
      var btn = this, err = q('[data-error]');
      var props = { 'Rase': state.breed || '', 'Bestillingstype': 'Forhåndsbestilling' };
      if (state.date) props['Ønsket leveringsdato'] = nice(state.date);
      if (state.pkg === 'premium' && state.name) props['Navneskilt'] = state.name;
      if (state.pkg === 'premium' && state.phone) props['Telefon på navneskilt'] = state.phone;
      if (state.age != null) props['Valpens alder ved levering'] = state.age + ' uker';
      btn.disabled = true;
      err.hidden = true;
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        window.location.href = root_url + 'cart';
      }).catch(function () {
        err.textContent = 'Noe gikk galt. Prøv igjen, eller kontakt oss.';
        err.hidden = false;
        btn.disabled = false;
      });
    });

    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lp-builder]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
